<!-- <pre class="text-left">{{component| json}}</pre> -->

<div class="cta-icon-wrap text-center pt-4">
    <img class="hiw-img" [width]="component.primary.icon.dimensions.width" [height]="component.primary.icon.dimensions.height" [alt]="component.primary.icon.alt" [src]="component.primary.icon.url" />
    <p class="cap-head"><strong>{{component.primary.caption[0].text}}</strong></p>
    <div class="">
        <a id="iconWithCtaButton" mdbBtn class="btn {{component.primary.cta_background_color ? component.primary.cta_background_color.toLowerCase(): 'primary'}}-btn mb-4 " mdbWavesEffect (click)="openLink(component.primary.link_to)">{{component.primary.cta_text ? component.primary.cta_text: 'Get Started' }}</a>
    </div>
</div>
